/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    InvoiceItem,
    InvoiceItemFromJSON,
    InvoiceItemFromJSONTyped,
    InvoiceItemToJSON,
} from './InvoiceItem';

/**
 * 請求データ
 * @export
 * @interface Invoice
 */
export interface Invoice {
    /**
     * 対象期間開始日
     * @type {string}
     * @memberof Invoice
     */
    startDate: string;
    /**
     * 対象期間終了日
     * @type {string}
     * @memberof Invoice
     */
    endDate: string;
    /**
     * 請求明細
     * @type {Array<InvoiceItem>}
     * @memberof Invoice
     */
    invoiceItems: Array<InvoiceItem>;
    /**
     * 税抜の合計請求額
     * @type {number}
     * @memberof Invoice
     */
    totalPriceWithoutTax: number;
    /**
     * 税込の合計請求額
     * @type {number}
     * @memberof Invoice
     */
    totalPrice: number;
}

export function InvoiceFromJSON(json: any): Invoice {
    return InvoiceFromJSONTyped(json, false);
}

export function InvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Invoice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startDate': json['start_date'],
        'endDate': json['end_date'],
        'invoiceItems': ((json['invoice_items'] as Array<any>).map(InvoiceItemFromJSON)),
        'totalPriceWithoutTax': json['total_price_without_tax'],
        'totalPrice': json['total_price'],
    };
}

export function InvoiceToJSON(value?: Invoice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start_date': value.startDate,
        'end_date': value.endDate,
        'invoice_items': ((value.invoiceItems as Array<any>).map(InvoiceItemToJSON)),
        'total_price_without_tax': value.totalPriceWithoutTax,
        'total_price': value.totalPrice,
    };
}

